import { render, staticRenderFns } from "./ApprovalSettings.vue?vue&type=template&id=03961284"
import script from "./ApprovalSettings.vue?vue&type=script&lang=js"
export * from "./ApprovalSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports